import { joinURL } from 'ufo'
import type { ApiPublicMachineryGetById } from '~/types'

function labelValueAsBulletPoint(label: string, value: string | number | null | undefined, placeholder = 'N/A') {
  return ` - ${label}: ${value ? String(value) : placeholder}`
}

export default (machinery?: ApiPublicMachineryGetById | null) => {
  const { $i18n } = useNuxtApp()

  const receptionMachineryValue = machinery?.receptionMachinery
  if (!receptionMachineryValue) {
    return undefined
  }

  const isPlatform = machinery.category === 'platform'
  const placeholder = $i18n.t('customerModule.empty.placeholder')

  return [
    machinery.id,
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.product.label'), receptionMachineryValue.product, placeholder),
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.type.label'), receptionMachineryValue.type?.name, placeholder),
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.yearBuilt.label'), receptionMachineryValue.yearBuilt, placeholder),
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.operatingHours.label'), receptionMachineryValue.operatingHours ? receptionMachineryValue.operatingHours + 50 : $i18n.t('customerModule.empty.placeholder'), placeholder),
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.liftingWeight.label'), receptionMachineryValue.liftingWeight, placeholder),
    isPlatform ? null : labelValueAsBulletPoint($i18n.t('customerModule.machinery.mast.label'), receptionMachineryValue.mast ? $i18n.t(`customerModule.machinery.mast.${receptionMachineryValue.mast}`) : $i18n.t('customerModule.empty.placeholder'), placeholder),
    isPlatform ? null : labelValueAsBulletPoint($i18n.t('customerModule.machinery.liftingHeightInMillimeters.label'), receptionMachineryValue.liftingHeightInMillimeters, placeholder),
    isPlatform ? labelValueAsBulletPoint($i18n.t('customerModule.machinery.workHeightInMillimeters.label'), receptionMachineryValue.workHeightInMillimeters, placeholder) : null,
    labelValueAsBulletPoint($i18n.t('customerModule.machinery.overallHeightInMillimeters.label'), receptionMachineryValue.overallHeightInMillimeters ?? receptionMachineryValue.mastOverallHeightInMillimeters, placeholder),
    '',
    `${$i18n.t('customerModule.machinery.forMoreInformation.label')}: ${joinURL(useFullCurrentUrl('onlyOrigin'), 'machinery', machinery.id)}`,
  ].filter(s => s !== null).join('\n')
}
